module.exports = __webpack_public_path__ + "media/KZ-ZAP.bf80d6e8.ogg";